import CustomButton from "common/components/Button/Button"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import VirtualDropdown from "common/components/VirtualDropdown/VirtualDropdown"
import useContactos from "features/Contactos/hooks/useContactos"
import { setIsSelectFilterActive } from "features/Contactos/redux/slices/contactoSlice"
import { INITIAL_QUERY_PARAMETERS } from "features/Crear/components/LibradoCard/constants"
import { useState } from "react"
import { useTranslation } from "react-i18next"

const RemesaInitialForm = ({
  hideModal,
  setFieldValue,
  values,
  handleSubmit,
  errors,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const [contactoSelected, setContactoSelected] = useState(null)
  const {
    contactosBySelect,
    getContactosBySelect,
    fetchingContactosBySelect,
    totalCount,
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  } = useContactos()

  const onSubmit = (e: $TSMigrationFixMe) => {
    e.preventDefault()

    handleSubmit(values)
  }

  const onHandleScroll = (queryParams: $TSMigrationFixMe) => {
    getContactosBySelect(queryParams)
  }

  const handleSelectContacto = (e: $TSMigrationFixMe) => {
    setContactoSelected(e.value)
    setFieldValue("empresaId", e.value.empresaContactoId)
  }
  return (
    <form onSubmit={onSubmit}>
      <div className='mb-3 select_container'>
        <label id='contactoSearch'>
          {t("remesas.edit.form.contactoLabel")}
        </label>
        <VirtualDropdown
          value={contactoSelected}
          errorMsg={
            errors?.empresaId && t("remesas.edit.form.contactoRequired")
          }
          emptyFilterMessage={t("remesas.edit.form.emptyMsg")}
          emptyMessage={t("remesas.edit.form.emptyMsg")}
          filter
          options={contactosBySelect || []}
          onChange={handleSelectContacto}
          placeholder={t("remesas.edit.form.placeholderContacto")}
          id='empresaId'
          name='empresaId'
          handleOnScroll={onHandleScroll}
          loading={fetchingContactosBySelect}
          startPage={20}
          fetchCallback={getContactosBySelect}
          initialQueryParameters={INITIAL_QUERY_PARAMETERS}
          setIsSelectFilterActive={setIsSelectFilterActive}
          totalCount={totalCount}
          userKey='librado'
          panelClassName='!tw-z-[3303]'
        />
      </div>
      <div className='mb-3 select_container'>
        <label htmlFor='nombreContacto'>
          {t("remesas.edit.form.importeLabel")}
        </label>
        <FormikInputText
          id='importe'
          name='importe'
          type='number'
          placeholder={t("remesas.edit.form.placeholderImporte")}
        />
      </div>
      <div className='departaments-modal__actions'>
        <p onClick={() => hideModal()}>{t("remesas.edit.form.cancelButton")}</p>
        <CustomButton
          type='submit'
          className='tw-ml-2 !tw-bg-primary tw-cursor-pointer'
        >
          {t("remesas.edit.form.continueButton")}
        </CustomButton>
      </div>
    </form>
  )
}

export default RemesaInitialForm
